import HelpTooltip from '@/app/common/components/HelpTooltip';
import type { ReactNode } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import { getColor } from '@/helpers/utils';
import { AiTwotoneAlert } from 'react-icons/ai';
import FalconCardHeader from '@/components/common/FalconCardHeader';
import ChecklistItem from './ChecklistItem';
import countSuffix from '@/helpers/countSuffix';
import type { ChecklistItemData } from './checklistTypes';

interface ChecklistCardProps {
  title: ReactNode;
  color: string;
  icon?: string;
  count?: number;
  data: ChecklistItemData[];
  tooltip?: ReactNode;
  searchText?: string;
}

// کارت جهت نمایش فهرست بازبینی
const ChecklistCard = ({
  title,
  color,
  count,
  data,
  tooltip,
  searchText
}: ChecklistCardProps): React.JSX.Element => {
  return (
    <Card className="h-md-100">
      <FalconCardHeader
        light
        title={
          <h4 className="fw-bold py-0 my-0 d-flex align-items-center justify-content-between gap-1">
            <span>
              <AiTwotoneAlert
                size={25}
                className="me-2"
                color={getColor(color)}
              />
              {title}
              <span className="fs-0">
                <HelpTooltip html={tooltip} />
              </span>
            </span>
            <h3 className={`ps-4 fw-bolder py-0 my-0 text-${color}`}>
              {countSuffix(count)}
            </h3>
          </h4>
        }
      />
      <Card.Body>
        <Row className="justify-content-between g-0">
          <Col className="pe-2 d-flex flex-column gap-1"></Col>
          <Col xs={12}>
            <ChecklistItem color={color} data={data} searchText={searchText} />
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default ChecklistCard;
